import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import InlineSVG from "react-inlinesvg";
import { WithReset } from "src/sudokit/Layout/BoxReset";
import Auth from "../../Auth";
import Pricing from "../Pricing";
import { isAndroid, isIOS, isMobileOnly } from 'react-device-detect';

export const MobileDeviceWarning = () => {
  useEffect(() => {
    const attemptMobileDeepLink = async () => {
      if (!isMobileOnly) {
        return;
      }

      try {
        const response = await Auth.fetchWithIdToken("/api/generate-mobile-signin-link", {
          method: "POST",
        });

        if (response.url) {
          const generatedUrl = new URL(response.url);
          const email = generatedUrl.searchParams.get("email");
          const linkKey = generatedUrl.searchParams.get("linkKey");

          if (email && linkKey) {
            const deepLinkParams = new URLSearchParams({
              email,
              linkKey,
            });

            if (isMobileOnly && isIOS) {
              window.location.href = `com.humanplusplus.sudowriteapp://authenticate_mobile/email-sign-in-verify?${deepLinkParams.toString()}`;
            } else if (isMobileOnly && isAndroid) {
              window.location.href = `intent://authenticate_mobile/email-sign-in-verify?${deepLinkParams.toString()}#Intent;package=com.humanplusplus.sudowrite;scheme=sudowrite;end`;
            }
          }
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    };

    attemptMobileDeepLink();
  }, []);

  return (
    <div id="mobile-warning">
      <Pricing
        hideFront={() => { }}
        showFront={() => { }}
        openLogin={() => { }}
        messageComponent={
          <WithReset className="flex flex-col gap-2 w-full pb-10">
            <WithReset className="flex flex-col gap-4 w-full rounded-xl px-4 py-5 bg-app-menu-color border border-app-grey-3">
              <p className="text-center font-medium text-lg font-sans text-app-grey-0 leading-6">To use Sudowrite on a mobile device, download our app for the best experience!</p>

              <div className="flex flex-row gap-3 items-center justify-center max-h-12 px-3">
                <div className="max-w-[9.5rem] w-full">
                  <a
                    href="https://apps.apple.com/app/sudowrite/id6740884542"
                    target="_blank"
                  >
                    <InlineSVG
                      src="/assets/apple-logo.svg"
                      className="max-w-[9.5rem] w-full"
                    />
                  </a>
                </div>

                <div className="max-w-44 w-full">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.humanplusplus.sudowrite&pcampaignid=mobile_warning"
                    target="_blank"
                  >
                    <img
                      src="/assets/get-it-on-playstore.png"
                      alt="Get it on Google Play"
                      className="w-full"
                    />
                  </a>
                </div>
              </div>
            </WithReset>
          </WithReset>
        }
      />
    </div>
  );
};
